import React from 'react';

import PageTemplate, {
  pageCommonPropTypes,
  renderCmsComponents,
} from './templates/PageTemplate';

const CategoryPage = ({ content = {}, fpti = {}, pageInfo = {} }) => {
  const {
    components = [],
    subNav,
    globalDisclosure,
    articleStickyButton,
  } = content.pageData || {};

  return (
    <PageTemplate
      fpti={fpti}
      subNav={subNav}
      pageInfo={pageInfo}
      globalDisclosure={globalDisclosure}
      articleStickyButton={articleStickyButton}
    >
      {renderCmsComponents(components, pageInfo)}
    </PageTemplate>
  );
};

CategoryPage.propTypes = pageCommonPropTypes;

export default CategoryPage;
